/*global gapi*/
import React, { Component } from 'react'
import makeUniqueId from 'helpers/makeUniqueId'

class GoogleClassroom extends Component {

	setElement = _prevRef => {
		try {
			const element_id = makeUniqueId()
			_prevRef.setAttribute('id', element_id)
			gapi.sharetoclassroom.render(element_id, {
				url: this.props.urlWeb,
				theme: 'classic',
				size: 48,
			} )
		} catch (err) {

		}
	}

	render() {
		const cloned = React.cloneElement(
			this.props.children[0],
			{
				ref: this.setElement,
			}
		)
		return cloned
	}
}

export default GoogleClassroom
